import CLUBS_JSON from '../config/los-cabos-clubs-config.json';
export default CLUBS_JSON;
